import { Component, Input, OnInit } from "@angular/core";
import { Hotspot, Infographic } from "../util";

@Component({
    selector: "app-mouse-popup-display",
    templateUrl: "./mouse-popup-display.component.html",
    styleUrls: ["./mouse-popup-display.component.scss"],
    host: {
        "(window:resize)": "onResize($event)",
        "(window:scroll)": "onScroll($event)",
    },
    standalone: false
})
export class MousePopupDisplayComponent implements OnInit {
  @Input() infographic: Infographic;
  activeHotspotIndex: number;
  clientCursorPosition: { x: number; y: number } = { x: 0, y: 0 };
  imageHeight: number = 0;
  constructor() {}

  onResize(event) {
    this.getImgHeight();
  }
  onScroll(event) {
    this.deactivateHotspot();
  }

  ngOnInit() {}
  getImgHeight() {
    this.imageHeight = document.getElementById(
      "infographic-image"
    ).offsetHeight;
    return this.imageHeight > 0 ? this.imageHeight : 64;
  }
  getButtonStyle(hotspot: Hotspot) {
    return {
      top: hotspot.topPercent.toString() + "%",
      left: hotspot.leftPercent.toString() + "%",
    };
  }
  isActive(index: number) {
    return this.activeHotspotIndex == index;
  }
  toggleHotspot(event: any, index: number) {
    this.activeHotspotIndex == index
      ? this.deactivateHotspot()
      : this.activateHotspot(event, index);
  }
  activateHotspot(event: any, index: number) {
    this.updateMousePosition(event);
    this.activeHotspotIndex = index;
  }
  deactivateHotspot() {
    this.activeHotspotIndex = undefined;
  }
  updateMousePosition(event: any) {
    this.clientCursorPosition = { x: event.clientX, y: event.clientY };
  }
  positionRelativeToCursor() {
    if (window.innerHeight - this.clientCursorPosition.y > 256)
      return {
        top: this.clientCursorPosition.y + 32 + "px",
        left: this.clientCursorPosition.x - 128 + "px",
      };
    else
      return {
        bottom: window.innerHeight - this.clientCursorPosition.y + 32 + "px",
        left: this.clientCursorPosition.x - 128 + "px",
      };
  }
  positionRelativeToMyButton(index: number) {
    let rect = document.getElementById("hotspot" + index).getClientRects()[0];

    return {
      top: rect.top + 40 + "px",
      left: rect.left - 128 + "px",
    };
  }
  goTo(link: string) {
    window.open(link, "_blank");
  }
}
